
import Vue, { PropType } from 'vue';
import { LocationTree, TreeBadge, TreeButton } from '@/interfaces/locationTree';

export default Vue.extend({
	name: 'TreeView',
	data() {
		return {
			showChildren: false,
		} as {
			showChildren: boolean;
		};
	},
	mounted() {
		this.showChildren = this.node.expanded;
	},
	props: {
		depth: { type: Number, default: 0 },
		node: { type: Object as PropType<LocationTree>, required: true },
		hasIdentifyRule: { type: Boolean, default: true },
	},
	computed: {
		indent(): { [option: string]: string } {
			if (innerWidth <= 768) {
				return { 'margin-left': `${this.depth * 20}px` };
			} else {
				return { 'margin-left': `${this.depth * 30}px` };
			}
		},

		identifier(): string {
			return `${this.node.category || 'unknown'}-${this.node.id}`;
		},

		badges(): TreeBadge[] {
			return this.node.badges ?? [];
		},

		buttons(): TreeButton[] {
			return this.node.buttons ?? [];
		},

		children(): LocationTree[] {
			return this.node.nodes ?? [];
		},
	},
	methods: {
		onNodeClick() {
			if (this.node.nodes) {
				this.toggleChildren();
			} else if (this.node.changeNavigation) {
				this.emitNavigation(this.node.changeNavigation);
			}
		},

		toggleChildren(): void {
			if (this.node.nodes) {
				this.showChildren = !this.showChildren;
				this.$emit('expanded', this.showChildren, this.node.category, this.node.id);
			}
		},

		onChildExpanded(state: boolean, category: string, id: number) {
			this.$emit('expanded', state, category, id);
		},

		emitNavigation(id: string) {
			this.$emit('navigation', id);
		},

		emitButton(category: string, name: string, id: number) {
			this.$emit('emitButton', category, name, id);
		},

		changeIdentify(id: number, identify: boolean) {
			this.$emit('changeIdentify', id, !identify);
		},

		changeOff(id: number, off: boolean) {
			this.$emit('changeOff', id, !off);
		},
	},
});
